import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ClientModel } from 'src/app/models/gum-models/client.model';
import { ClientService } from 'src/app/services/gumservices/client.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ConfirmDialogComponent } from '../dialogs/confirm-dialog/confirm-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-gum-client',
  templateUrl: './gum-client.component.html',
  styleUrls: ['./gum-client.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatPaginator,
    MatPaginatorModule,
  ],
})
export class GumClientComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  displayedColumns: string[] = [
    'nom',
    'Siret',
    'Email',
    'Phone',
    'City',
    'actions',
  ];
  dataSource = new MatTableDataSource<ClientModel>();
  filterValue = '';
  filtersForm!: FormGroup;

  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private clientService: ClientService,
    private dialog: MatDialog,
    private router: Router,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.filtersForm = this.fb.group({
      nom: [''],
      Siret: [''],
      Email: [''],
      Phone: [''],
      City: [''],
    });

    this.refreshClients();
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  refreshClients(): void {
    this.clientService.getClients(true).subscribe((clients) => {
      this.dataSource.data = clients;
      this.applyFilters();
    });
  }

  applyFilters(): void {
    const values = this.filtersForm.value;
    this.dataSource.filterPredicate = (data: ClientModel, filter: string) => {
      const terms = JSON.parse(filter);
      return Object.keys(terms).every((key) => {
        const val = (data as any)[key];
        return (
          !terms[key] || val?.toLowerCase().includes(terms[key].toLowerCase())
        );
      });
    };

    this.dataSource.filter = JSON.stringify(values);
  }

  resetColumnFilter(column: string): void {
    this.filtersForm.get(column)?.setValue('');
    this.applyFilters();
  }

  resetAllFilters(): void {
    this.filtersForm.reset();
    this.applyFilters();
  }

  createClient(): void {
    this.router.navigate(['/management/clients']);
  }

  editClient(client: ClientModel): void {
    this.router.navigate(['/management/clients', client.id]);
  }

  // toggleActivation(client: ClientModel): void {
  //   const updated = !client.enabled;
  //   this.clientService.setClientEnabled(client.id!, updated).subscribe(() => {
  //     client.enabled = updated;
  //   });
  // }

  confirmDelete(client: ClientModel): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Supprimer ce client ?',
        message: `Cette action supprimera définitivement le client "${client.nom}".`,
        confirmText: 'Supprimer',
        cancelText: 'Annuler',
      },
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        this.clientService
          .deleteClient(client.id!)
          .subscribe(() => this.refreshClients());
      }
    });
  }
}
